var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TheHeader'),_c('main',[_c('router-view')],1),_c('TheFooter'),_c('FloatingSidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }